import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FaqAccordion = ({ items, testId = 'faq' }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-slate-200 border border-slate-200 rounded-2xl overflow-hidden bg-white" data-testid={testId}>
      {items.map((item, i) => (
        <div key={i}>
          <button
            type="button"
            onClick={() => setOpen(open === i ? -1 : i)}
            data-testid={`${testId}-q-${i}`}
            className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-slate-50 transition-colors"
            aria-expanded={open === i}
          >
            <span className="font-semibold text-slate-900">{item.q}</span>
            <ChevronDown
              className={`h-5 w-5 text-emerald-600 flex-shrink-0 transition-transform duration-300 ${open === i ? 'rotate-180' : ''}`}
            />
          </button>
          {open === i && (
            <div className="px-5 pb-5 text-slate-600 leading-relaxed" data-testid={`${testId}-a-${i}`}>
              {item.a}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FaqAccordion;
